module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0037.jpg?v=a1c48ad6";